"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _internal = require("@/components/uploadPicture/internal");
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var _rsManagement = require("@/api/rsManagement");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _rensouApi = require("@/api/rensou/rensouApi");
var _StoreAddressPicker = _interopRequireDefault(require("./StoreAddressPicker.vue"));
var _BusinessHoursPicker = _interopRequireDefault(require("./BusinessHoursPicker.vue"));
var _businessHoursUtils = require("./businessHoursUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'StoreForm',
  components: {
    Tinymce: _index.default,
    StoreAddressPicker: _StoreAddressPicker.default,
    BusinessHoursPicker: _BusinessHoursPicker.default
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    storeData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    storeId: {
      type: [String, Number],
      default: null
    },
    supplierOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this2 = this;
    var validateBusinessTimeList = function validateBusinessTimeList(rule, value, callback) {
      var businessTimeList = (0, _businessHoursUtils.serializeBusinessTimeList)(value || []);
      if (!businessTimeList.length) {
        callback(new Error('请完善营业时间'));
        return;
      }
      callback();
    };
    return {
      dialogVisible: this.visible,
      frtTemplateOptions: [],
      isChoseWmTgFlag: false,
      formData: {
        //模板id
        deliveryTemplateId: null,
        // 当前选中配送模板的 type，兼容编辑回显（提交时移除）
        deliveryTemplateType: null,
        // 顺丰模板(type=2)专用字段
        sfLogisticsId: '',
        sfFlag: 1,
        autoDelivery: 1,
        frtTemplateId: null,
        // 基本信息
        supplierId: null,
        storeTypes: [],
        storeStatus: '',
        storeName: '',
        logo: '',
        imageUrlList: [],
        online: true,
        // 地址信息 - 改为数组支持级联选择
        region: [],
        storeAddress: '',
        longitude: '',
        latitude: '',
        // 运营信息
        deliveryStartFee: 0,
        wmTgFlag: [],
        packingFee: 0,
        maxMealTime: '',
        isSelfPickup: 0,
        isExpress: 0,
        isTakeout: 0,
        deliveryTypes: [],
        businessStatus: '',
        businessTimeList: (0, _businessHoursUtils.createEmptyList)(),
        phone: '',
        wechatId: '',
        smsPhone: '',
        messageNotifyFlag: 0,
        // 其他
        storeDesc: '',
        usePrinterDevice: false,
        printerSn: '',
        ticketTemplateIds: [],
        usePrinterDevice2: false,
        printerSn2: '',
        email: '',
        remark: '',
        // 酒店退款配置
        hotelRefundConfigs: [],
        // 退款时间段列表
        cancelLimitHour: 24 // 距离入住多少小时以内不可取消
      },
      // 保存初始打印机序列号，用于判断是否允许编辑
      originalPrinterSn: '',
      originalPrinterSn2: '',
      receiptTemplateOptions: [],
      receiptTemplateLoading: false,
      formRules: {
        supplierId: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (value === null || value === '' || value === undefined) {
              callback(new Error('请选择所属商户'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        storeTypes: [{
          required: true,
          validator: this.validateStoreTypes,
          trigger: 'change'
        }],
        storeName: [{
          required: true,
          message: '请输入店铺名称',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value || value.length < 3) {
              callback(new Error('请选择完整的省市区'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        storeAddress: [{
          required: true,
          message: '请填写门店具体位置',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入门店联系电话',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback();
              return;
            }

            // 支持多个号码，用逗号、分号、空格或换行分隔
            var phoneNumbers = value.split(/[,]+/).filter(function (phone) {
              return phone.trim();
            });
            if (phoneNumbers.length === 0) {
              callback();
              return;
            }

            // 校验每个号码
            for (var i = 0; i < phoneNumbers.length; i++) {
              var phone = phoneNumbers[i].trim();
              if (!phone) continue;

              // 手机号格式：1[3-9]xxxxxxxxx
              var mobilePattern = /^1[3-9]\d{9}$/;
              // 座机格式：区号-号码-分机号（分机号可选）
              var landlinePattern = /^0\d{2,3}-?\d{7,8}(-\d{1,4})?$/;
              // 400/800电话格式
              var servicePattern = /^[48]00-?\d{3}-?\d{4}$/;
              if (!mobilePattern.test(phone) && !landlinePattern.test(phone) && !servicePattern.test(phone)) {
                callback(new Error("\u7B2C".concat(i + 1, "\u4E2A\u53F7\u7801\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u652F\u6301\u624B\u673A\u53F7\u3001\u5EA7\u673A\u53F7\u3001400/800\u7535\u8BDD")));
                return;
              }
            }
            callback();
          },
          trigger: 'blur'
        }],
        wechatId: [{
          validator: this.validateWechatId,
          trigger: 'blur'
        }],
        messageNotifyFlag: [{
          required: true,
          validator: this.validateNotifyFlag('消息通知'),
          trigger: 'change'
        }],
        smsPhone: [{
          validator: this.validateSmsPhone,
          trigger: 'blur'
        }],
        logo: [{
          required: true,
          message: '请上传店铺LOGO',
          trigger: 'change'
        }],
        imageUrlList: [
        // 主图改为非必填
        {
          validator: function validator(rule, value, callback) {
            if (value && value.length > 10) {
              callback(new Error('主图最多上传10张'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        storeStatus: [{
          required: true,
          message: '请选择门店状态',
          trigger: 'change'
        }],
        longitude: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value || !_this2.formData.latitude) {
              callback(new Error('请在地图上选择位置'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        businessStatus: [{
          required: true,
          message: '请选择经营状态',
          trigger: 'change'
        }],
        businessTimeList: [{
          validator: validateBusinessTimeList,
          trigger: 'change'
        }],
        /*         isSelfPickup: [
                  { required: true, message: '请选择是否支持自提', trigger: 'change' }
                ], */
        deliveryStartFee: [{
          required: true,
          message: '请输入起送费',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value < 0) {
              callback(new Error('起送费不能为负数'));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'change']
        }],
        wmTgFlag: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value || value.length === 0) {
              callback(new Error('请至少选择一个外卖/团购类型'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        deliveryTypes: [{
          type: 'array',
          required: true,
          min: 1,
          message: '至少选择一种配送方式',
          trigger: 'change'
        }],
        packingFee: [{
          required: true,
          message: '请输入打包费',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value < 0) {
              callback(new Error('打包费不能为负数'));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'change']
        }],
        deliveryTemplateId: [{
          required: true,
          message: '请选择配送模板',
          trigger: 'change'
        }],
        sfLogisticsId: [{
          validator: function validator(rule, value, callback) {
            if (!_this2.isSfTemplateSelected) {
              callback();
              return;
            }
            if (value == null || String(value).trim() === '') {
              callback(new Error('请输入顺丰门店ID'));
              return;
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        sfFlag: [{
          validator: function validator(rule, value, callback) {
            if (!_this2.isSfTemplateSelected) {
              callback();
              return;
            }
            var n = value === '' || value === null || value === undefined ? null : Number(value);
            if (n !== 0 && n !== 1) {
              callback(new Error('请选择是否顺丰门店'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        maxMealTime: [{
          required: true,
          validator: this.validateMaxMealTime,
          trigger: ['blur', 'change']
        }],
        frtTemplateId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        usePrinterDevice: [{
          required: true,
          message: '请选择是否使用打印设备',
          trigger: 'change'
        }],
        printerSn: [{
          validator: function validator(rule, value, callback) {
            if (_this2.formData.usePrinterDevice && (!value || value.trim() === '')) {
              callback(new Error('使用打印设备时，打印机序列号不能为空'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        ticketTemplateIds: [{
          validator: function validator(rule, value, callback) {
            if (!_this2.showReceiptTemplateField) {
              callback();
              return;
            }
            if (!value || !Array.isArray(value) || value.length === 0) {
              callback(new Error('请选择小票模板'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        usePrinterDevice2: [{
          required: true,
          message: '请选择是否使用酒店打印设备',
          trigger: 'change'
        }],
        printerSn2: [{
          validator: function validator(rule, value, callback) {
            if (_this2.formData.usePrinterDevice2 && (!value || value.trim() === '')) {
              callback(new Error('使用酒店打印设备时，打印机序列号不能为空'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        email: [{
          validator: this.validateNotifyEmail,
          trigger: 'blur'
        }]
      },
      // 地区选项
      areaOptions: [],
      // 店铺类型选项
      storeTypeOptions: [],
      //此处为暂存的全部数据
      storeTypeOptionsToChose: [],
      //此处为选择业务类型后可用的数据
      storeTypeLoading: false,
      // 配送模板选项
      shippingTemplateOptions: [],
      // 配送模板加载状态
      shippingTemplateLoading: false,
      // 图片预览相关
      imagePreviewVisible: false,
      currentPreviewImage: '',
      isMainImagePreview: false,
      currentImageIndex: 0,
      tinymceEditor: null
    };
  },
  mounted: function mounted() {
    this.getAreaData();
    this.getShippingTemplateData(); // 初始化时获取所有配送模板
    this.getExpressTemplateData(); // 初始化时获取所有配送模板
    //this.fetchStoreTypeOptions() 移到监听表单打开里
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑店铺' : '添加店铺';
    },
    // 确保商户选项数据格式正确
    normalizedSupplierOptions: function normalizedSupplierOptions() {
      return this.supplierOptions.map(function (item) {
        return {
          value: Number(item.value),
          label: item.label
        };
      });
    },
    // 判断是否选择了实物
    hasProduct: function hasProduct() {
      if (!this.formData.wmTgFlag || !Array.isArray(this.formData.wmTgFlag)) {
        return false;
      }
      return this.formData.wmTgFlag.includes('1');
    },
    // 判断是否选择了外卖
    hasTakeout: function hasTakeout() {
      return this.formData.isTakeout;
    },
    // 判断是否选择了自提
    hasPickup: function hasPickup() {
      return this.formData.isSelfPickup;
    },
    // 判断是否选择了自提
    hasExpress: function hasExpress() {
      return this.formData.isExpress;
    },
    // 判断是否选择了团购
    hasGroupBuy: function hasGroupBuy() {
      if (!this.formData.wmTgFlag || !Array.isArray(this.formData.wmTgFlag)) {
        return false;
      }
      return this.formData.wmTgFlag.includes('2');
    },
    // 判断是否选择了酒店
    hasHotel: function hasHotel() {
      if (!this.formData.wmTgFlag || !Array.isArray(this.formData.wmTgFlag)) {
        return false;
      }
      return this.formData.wmTgFlag.includes('3');
    },
    // 酒店退款配置默认行
    defaultHotelRefundConfigs: function defaultHotelRefundConfigs() {
      return [{
        startHour: 96,
        endHour: null,
        refundRate: 100,
        disabled: true
      }, {
        startHour: 72,
        endHour: 96,
        refundRate: 70,
        disabled: false
      }, {
        startHour: 48,
        endHour: 72,
        refundRate: 50,
        disabled: false
      }, {
        startHour: 24,
        endHour: 48,
        refundRate: 20,
        disabled: false
      }];
    },
    hotelRefundCancelLimitHour: function hotelRefundCancelLimitHour() {
      var list = this.formData.hotelRefundConfigs || [];
      var lastItem = list[list.length - 1];
      return lastItem && Number(lastItem.startHour) > 0 ? Number(lastItem.startHour) : 0;
    },
    isSfTemplateSelected: function isSfTemplateSelected() {
      var type = this.getResolvedDeliveryTemplateType();
      return Number(type) === 2;
    },
    selectedDeliveryTemplate: function selectedDeliveryTemplate() {
      var _this3 = this;
      if (!this.formData.deliveryTemplateId) return null;
      return this.shippingTemplateOptions.find(function (item) {
        return String(item.key) === String(_this3.formData.deliveryTemplateId);
      }) || null;
    },
    showAutoDelivery: function showAutoDelivery() {
      var type = this.getResolvedDeliveryTemplateType();
      return Number(type) === 3;
    },
    showReceiptTemplateField: function showReceiptTemplateField() {
      return this.hasTakeout && this.formData.usePrinterDevice === true;
    }
  },
  watch: {
    visible: function visible(val) {
      var _this4 = this;
      console.log('visible watch triggered, val:', val, 'isEdit:', this.isEdit, 'storeId:', this.storeId);
      this.dialogVisible = val;
      if (val) {
        this.loadReceiptTemplateOptions();
        // 弹窗打开时的逻辑判断
        if (this.isEdit && this.storeId) {
          // 编辑模式：先尝试使用storeData初始化，如果没有则获取详情
          console.log('编辑模式：开始初始化表单');
          if (this.storeData && Object.keys(this.storeData).length > 0) {
            console.log('使用storeData初始化表单');
            this.initFormData();
          } else {
            console.log('storeData为空，开始获取店铺详情');
            this.getStoreDetail();
          }
        } else {
          // 新增模式：重置表单为空
          console.log('新增模式：开始重置表单');
          this.resetForm();
        }

        // 修复：确保富文本编辑器在弹窗打开后正确初始化
        this.$nextTick(function () {
          if (_this4.$refs.tinymceEditor && !_this4.$refs.tinymceEditor.hasInit) {
            // 如果编辑器还没有初始化，等待一下再尝试设置内容
            setTimeout(function () {
              if (_this4.formData.storeDesc && _this4.$refs.tinymceEditor.hasInit) {
                _this4.$refs.tinymceEditor.setContent(_this4.formData.storeDesc);
                console.log('延迟设置富文本编辑器内容:', _this4.formData.storeDesc);
              }
            }, 100);
          }
        });
      } else {
        // 弹窗关闭时，清空表单数据，避免数据残留
        console.log('弹窗关闭：清空表单数据');
        this.resetForm();
      }
    },
    dialogVisible: function dialogVisible(val) {
      this.$emit('update:visible', val);
    },
    supplierOptions: {
      handler: function handler(newVal) {
        var _this5 = this;
        console.log('StoreForm: supplierOptions updated', newVal);
        // 当商户选项更新时，确保表单中的supplierId仍然有效
        if (this.formData.supplierId && newVal && newVal.length > 0) {
          var exists = newVal.some(function (item) {
            return item.value === _this5.formData.supplierId;
          });
          if (!exists) {
            // 如果当前选中的商户不在新的选项中，清空选择
            this.formData.supplierId = null;
          }
        }
      },
      deep: true,
      immediate: true
    },
    storeData: {
      handler: function handler(newVal) {
        console.log('StoreForm: storeData updated', newVal);
        // 当storeData更新时，如果是编辑模式且弹窗已打开，则重新初始化表单
        if (this.isEdit && this.dialogVisible && newVal && Object.keys(newVal).length > 0) {
          console.log('storeData更新，重新初始化表单');
          this.initFormData();
        }
      },
      deep: true
    },
    // 监听业务类型变化，初始化/清空酒店退款配置
    'formData.wmTgFlag': {
      immediate: true,
      handler: function handler(val) {
        var hasHotel = Array.isArray(val) && val.includes('3');
        if (hasHotel) {
          if (!this.formData.hotelRefundConfigs || this.formData.hotelRefundConfigs.length === 0) {
            this.initHotelRefundConfigs();
          } else {
            this.syncHotelRefundConfigRanges();
          }
        }
      }
    },
    'formData.deliveryTypes': {
      immediate: true,
      handler: function handler(val) {
        var types = val || [];
        this.formData.isTakeout = types.includes('takeout') ? 1 : 0;
        this.formData.isSelfPickup = types.includes('self_pickup') ? 1 : 0;
        this.formData.isExpress = types.includes('express') ? 1 : 0;
        if (!types.includes('takeout')) {
          this.formData.ticketTemplateIds = [];
        }
      }
    },
    'formData.usePrinterDevice': function formDataUsePrinterDevice(val) {
      var _this6 = this;
      if (!val) {
        this.formData.ticketTemplateIds = [];
        this.$nextTick(function () {
          if (_this6.$refs.storeForm) {
            _this6.$refs.storeForm.clearValidate(['ticketTemplateIds']);
          }
        });
      }
    },
    'formData.deliveryTemplateId': function formDataDeliveryTemplateId() {
      var _this7 = this;
      this.$nextTick(function () {
        return _this7.onDeliveryTemplateContextChanged();
      });
    },
    shippingTemplateOptions: {
      handler: function handler() {
        var _this8 = this;
        this.$nextTick(function () {
          return _this8.onDeliveryTemplateContextChanged();
        });
      },
      deep: true
    },
    isSfTemplateSelected: function isSfTemplateSelected(val) {
      var _this9 = this;
      this.$nextTick(function () {
        if (_this9.$refs.storeForm && !val) {
          _this9.$refs.storeForm.clearValidate(['sfLogisticsId', 'sfFlag']);
        }
      });
    }
  },
  methods: {
    // 后端保存为 JSON 字符串，表单渲染统一使用数组，避免 v-for 将字符串按字符展开。
    parseHotelRefundConfigs: function parseHotelRefundConfigs(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value !== 'string' || !value.trim()) {
        return [];
      }
      try {
        var parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.warn('酒店退款配置解析失败', error);
        return [];
      }
    },
    loadReceiptTemplateOptions: function loadReceiptTemplateOptions() {
      this.searchReceiptTemplates('');
    },
    searchReceiptTemplates: function searchReceiptTemplates(query) {
      var _this0 = this;
      this.receiptTemplateLoading = true;
      (0, _rsManagement.getTicketTemplateAutoList)({
        templateName: (query || '').trim() || undefined
      }).then(function (res) {
        var list = Array.isArray(res) ? res : res.list || [];
        var filtered = list.filter(function (item) {
          return Number(item.status) === 1 && Number(item.sceneType) === 1;
        });
        _this0.mergeReceiptTemplateOptions(filtered);
      }).catch(function () {
        // 保留已选回显项，避免远程搜索失败时下拉空白
      }).finally(function () {
        _this0.receiptTemplateLoading = false;
      });
    },
    normalizeTicketTemplateIds: function normalizeTicketTemplateIds(value) {
      if (value == null || value === '') return [];
      if (Array.isArray(value)) {
        return value.map(function (item) {
          return String(item);
        }).filter(function (item) {
          return item !== '';
        });
      }
      if (typeof value === 'string') {
        return value.split(',').map(function (item) {
          return item.trim();
        }).filter(function (item) {
          return item !== '';
        });
      }
      return [String(value)];
    },
    normalizeTicketTemplateNameList: function normalizeTicketTemplateNameList(value) {
      if (value == null || value === '') return [];
      if (Array.isArray(value)) {
        return value.map(function (item) {
          return String(item);
        }).filter(function (item) {
          return item !== '';
        });
      }
      if (typeof value === 'string') {
        return value.split(',').map(function (item) {
          return item.trim();
        }).filter(function (item) {
          return item !== '';
        });
      }
      return [String(value)];
    },
    mergeReceiptTemplateOptions: function mergeReceiptTemplateOptions(options) {
      var map = new Map();
      (this.receiptTemplateOptions || []).forEach(function (item) {
        map.set(String(item.id), item);
      });
      (options || []).forEach(function (item) {
        if (item == null || item.id == null || item.id === '') return;
        map.set(String(item.id), _objectSpread(_objectSpread({}, map.get(String(item.id))), item));
      });
      this.receiptTemplateOptions = Array.from(map.values());
    },
    applyTicketTemplateEcho: function applyTicketTemplateEcho(ids, nameList) {
      var normalizedIds = this.normalizeTicketTemplateIds(ids);
      var names = this.normalizeTicketTemplateNameList(nameList);
      var echoOptions = normalizedIds.map(function (id, index) {
        return {
          id: Number(id) || id,
          templateName: names[index] || "\u6A21\u677F".concat(id),
          status: 1,
          sceneType: 1
        };
      });
      this.mergeReceiptTemplateOptions(echoOptions);
      return normalizedIds;
    },
    // 解析当前配送模板 type：优先下拉选项中的 type，其次回显字段 deliveryTemplateType
    getResolvedDeliveryTemplateType: function getResolvedDeliveryTemplateType() {
      var id = this.formData.deliveryTemplateId;
      if (id == null || id === '') return null;
      var t = this.shippingTemplateOptions.find(function (x) {
        return String(x.key) === String(id);
      });
      if (t && t.type != null && t.type !== '') return Number(t.type);
      if (this.formData.deliveryTemplateType != null && this.formData.deliveryTemplateType !== '') {
        return Number(this.formData.deliveryTemplateType);
      }
      return null;
    },
    // 模板上下文变化时，统一维护顺丰字段与模板type回显字段
    onDeliveryTemplateContextChanged: function onDeliveryTemplateContextChanged() {
      var _this1 = this;
      var id = this.formData.deliveryTemplateId;
      var t = this.shippingTemplateOptions.find(function (x) {
        return String(x.key) === String(id);
      });
      if (t && t.type != null && t.type !== '') {
        this.$set(this.formData, 'deliveryTemplateType', Number(t.type));
      }
      if (id == null || id === '') {
        this.$set(this.formData, 'deliveryTemplateType', null);
        this.$set(this.formData, 'sfLogisticsId', '');
        this.$set(this.formData, 'sfFlag', 1);
        this.$nextTick(function () {
          _this1.$refs.storeForm && _this1.$refs.storeForm.clearValidate(['sfLogisticsId', 'sfFlag']);
        });
        return;
      }
      var resolved = this.getResolvedDeliveryTemplateType();
      if (resolved == null) return;
      if (Number(resolved) !== 2) {
        this.$set(this.formData, 'sfLogisticsId', '');
        this.$set(this.formData, 'sfFlag', 1);
        this.$nextTick(function () {
          _this1.$refs.storeForm && _this1.$refs.storeForm.clearValidate(['sfLogisticsId', 'sfFlag']);
        });
      } else if (this.formData.sfFlag == null || this.formData.sfFlag === '') {
        this.$set(this.formData, 'sfFlag', 1);
      }
    },
    // ==================== 酒店退款配置 ====================
    // 初始化酒店退款配置（进入酒店类型时调用）
    initHotelRefundConfigs: function initHotelRefundConfigs() {
      var list = this.defaultHotelRefundConfigs.map(function (item) {
        return _objectSpread({}, item);
      });
      this.formData.hotelRefundConfigs = list;
      this.syncHotelRefundConfigRanges();
    },
    // 恢复新增店铺时的默认退款规则。
    handleResetHotelRefundConfigs: function handleResetHotelRefundConfigs() {
      this.initHotelRefundConfigs();
    },
    // 最后一档起始小时变化后重新同步区间和不可取消边界。
    handleRefundStartHourChange: function handleRefundStartHourChange(index, val) {
      this.syncHotelRefundConfigRanges();
    },
    // 新增一行退款配置：仅在最后一项后追加，确保时间范围连续且不重叠
    handleAddRefundRow: function handleAddRefundRow() {
      var list = this.formData.hotelRefundConfigs || [];
      if (list.length >= 11) {
        // 最多10行（含固定第1行=11条）
        this.$message.warning('最多新增10项');
        return;
      }
      var lastItem = list[list.length - 1];
      var newEndHour = Number(lastItem.startHour);
      if (!Number.isInteger(newEndHour) || newEndHour <= 1) {
        this.$message.warning('当前时间边界无法继续新增');
        return;
      }
      list.push({
        startHour: Math.max(1, newEndHour - 24),
        endHour: newEndHour,
        refundRate: Number(lastItem.refundRate) || 1,
        disabled: false
      });
      this.syncHotelRefundConfigRanges();
    },
    // 删除一行退款配置
    handleRemoveRefundRow: function handleRemoveRefundRow(index) {
      var list = this.formData.hotelRefundConfigs;
      if (list.length <= 1) {
        // 固定首项不可删除
        this.$message.warning('至少保留首项退款配置');
        return;
      }
      if (index !== list.length - 2) {
        return;
      }
      list.splice(index + 1, 1);
      this.syncHotelRefundConfigRanges();
    },
    // 统一衔接各退款区间，并让不可取消时间始终取最后一项起始小时。
    syncHotelRefundConfigRanges: function syncHotelRefundConfigRanges() {
      var list = this.formData.hotelRefundConfigs || [];
      if (!list.length) return;
      this.$set(list[0], 'endHour', null);
      for (var i = 1; i < list.length; i++) {
        var previousStartHour = list[i - 1].startHour;
        var hasPreviousStartHour = previousStartHour !== null && previousStartHour !== '' && Number.isInteger(Number(previousStartHour)) && Number(previousStartHour) > 0;
        this.$set(list[i], 'endHour', hasPreviousStartHour ? Number(previousStartHour) : null);
      }
      var lastItem = list[list.length - 1];
      var lastStartHour = lastItem && lastItem.startHour;
      this.formData.cancelLimitHour = lastStartHour !== null && lastStartHour !== '' && Number.isInteger(Number(lastStartHour)) && Number(lastStartHour) > 0 ? Number(lastStartHour) : null;
    },
    // 酒店退款规则属于酒店店铺的必填配置，提交前校验完整性。
    validateHotelRefundConfigs: function validateHotelRefundConfigs() {
      var list = this.formData.hotelRefundConfigs;
      var invalid = !Array.isArray(list) || list.length === 0 || list.some(function (item, index) {
        var startHour = Number(item.startHour);
        var endHour = index === 0 ? null : Number(item.endHour);
        var refundRate = Number(item.refundRate);
        var hasStartHour = item.startHour !== null && item.startHour !== '' && Number.isInteger(startHour) && startHour > 0;
        var hasEndHour = index === 0 || item.endHour !== null && item.endHour !== '' && Number.isInteger(endHour);
        var continuous = index === 0 || endHour === Number(list[index - 1].startHour) && startHour < endHour;
        return !hasStartHour || !hasEndHour || !continuous || index === 0 && refundRate !== 100 || !Number.isFinite(refundRate) || refundRate <= 0 || refundRate > 100;
      });
      if (invalid) {
        this.$message.error('请完整填写取消订单店铺退款配置');
        return false;
      }
      return true;
    },
    // ==================== /酒店退款配置 ====================
    // 获取运费模板列表
    getExpressTemplateData: function () {
      var _getExpressTemplateData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _rensouApi.shippingDropList)();
            case 1:
              res = _context.v;
              if (res && res.length > 0) {
                this.frtTemplateOptions = res.map(function (item) {
                  return {
                    label: item.value,
                    value: item.key
                  };
                });
              } else {
                this.frtTemplateOptions = [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取运费模板列表失败:', _t);
              this.$message.error('获取运费模板列表失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getExpressTemplateData() {
        return _getExpressTemplateData.apply(this, arguments);
      }
      return getExpressTemplateData;
    }(),
    normalizeStoreTypeValue: function normalizeStoreTypeValue(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      var numValue = Number(value);
      return Number.isNaN(numValue) ? String(value) : numValue;
    },
    parseStoreTypes: function parseStoreTypes(value) {
      var _this10 = this;
      if (value === null || value === undefined || value === '') {
        return [];
      }
      var values = Array.isArray(value) ? value : String(value).split(',');
      return values.map(function (item) {
        return _this10.normalizeStoreTypeValue(String(item).trim());
      }).filter(function (item) {
        return item !== '';
      });
    },
    validateStoreTypes: function validateStoreTypes(rule, value, callback) {
      var selectedBusinessTypes = Array.isArray(this.formData.wmTgFlag) ? this.formData.wmTgFlag.map(function (item) {
        return String(item);
      }) : [];
      var selectedStoreTypes = this.parseStoreTypes(value);
      if (!selectedStoreTypes.length) {
        callback(new Error('请选择店铺类型'));
        return;
      }
      if (!selectedBusinessTypes.length) {
        callback();
        return;
      }
      if (!this.storeTypeOptions.length) {
        callback(new Error('店铺类型数据未加载完成，请稍后重试'));
        return;
      }
      var selectedTypeSet = new Set(selectedStoreTypes.map(function (item) {
        return String(item);
      }));
      var coveredBusinessTypes = new Set(this.storeTypeOptions.filter(function (item) {
        return selectedTypeSet.has(String(item.key));
      }).map(function (item) {
        return String(item.type);
      }));
      var missingBusinessTypes = selectedBusinessTypes.filter(function (type) {
        return !coveredBusinessTypes.has(type);
      });
      if (missingBusinessTypes.length) {
        callback(new Error("\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A".concat(missingBusinessTypes.map(this.getBusinessTypeName).join('、'), "\u7C7B\u578B\u4E0B\u7684\u5E97\u94FA\u7C7B\u578B")));
        return;
      }
      callback();
    },
    getBusinessTypeName: function getBusinessTypeName(type) {
      var map = {
        '1': '实物',
        '2': '团购',
        '3': '酒店'
      };
      return map[String(type)] || type;
    },
    refreshStoreTypeOptions: function refreshStoreTypeOptions() {
      var wmTgFlagList = Array.isArray(this.formData.wmTgFlag) ? this.formData.wmTgFlag.map(function (item) {
        return String(item);
      }) : [];
      var selectedStoreTypes = this.parseStoreTypes(this.formData.storeTypes);
      this.storeTypeOptionsToChose = this.storeTypeOptions.filter(function (item) {
        return wmTgFlagList.includes(String(item.type));
      });
      if (!this.storeTypeOptions.length) {
        this.formData.storeTypes = selectedStoreTypes;
        return;
      }
      var availableIds = new Set(this.storeTypeOptionsToChose.map(function (item) {
        return String(item.key);
      }));
      this.formData.storeTypes = selectedStoreTypes.filter(function (item) {
        return availableIds.has(String(item));
      });
    },
    //监听业务类型变化
    wmTgFlagChange: function wmTgFlagChange() {
      var _this11 = this;
      this.formData.storeTypes = [];
      this.isChoseWmTgFlag = this.formData.wmTgFlag.length > 0;
      this.refreshStoreTypeOptions();
      this.$nextTick(function () {
        if (_this11.$refs.storeForm) {
          _this11.$refs.storeForm.clearValidate('storeTypes');
        }
      });
      if (this.isChoseWmTgFlag && !this.storeTypeOptions.length) {
        this.fetchStoreTypeOptions();
      }
      if (!this.formData.wmTgFlag.includes('1')) {
        this.formData.deliveryTypes = [];
        this.formData.isExpress = 0;
        this.formData.isTakeout = 0;
        this.formData.isSelfPickup = 0;
      }
    },
    // 处理富文本编辑器内容变化
    handleTinymceChange: function handleTinymceChange(content) {
      console.log('富文本编辑器内容变化:', content);
      this.formData.storeDesc = content;
    },
    // 处理是否使用打印设备变化
    handleUsePrinterDeviceChange: function handleUsePrinterDeviceChange(value) {
      console.log('是否使用打印设备变化:', value);
      console.log('当前editType:', this.formData.editType);
      console.log('当前originalPrinterSn:', this.originalPrinterSn);
      console.log('当前formData.printerSn:', this.formData.printerSn);

      // 当选择"否"时，清空打印机序列号
      if (value === false) {
        this.formData.printerSn = '';
        this.formData.printerSn2 = '';
      }

      // 计算禁用状态
      var hasOriginalValue = Boolean(this.originalPrinterSn && this.originalPrinterSn.trim());
      var isDisabled = !value || Number(this.formData.editType) === 2 && hasOriginalValue;
      console.log('计算的禁用状态:', isDisabled);
      console.log('editType类型:', _typeof(this.formData.editType), '值:', this.formData.editType);
      console.log('Number(editType) === 2:', Number(this.formData.editType) === 2);
      console.log('originalPrinterSn有值:', hasOriginalValue);
      console.log('详细分析: originalPrinterSn=', this.originalPrinterSn, 'trim()=', this.originalPrinterSn ? this.originalPrinterSn.trim() : 'null');
    },
    handleMessageNotifyChange: function handleMessageNotifyChange(val) {
      if (val !== 1 && this.$refs.storeForm) {
        this.$refs.storeForm.clearValidate(['email', 'wechatId', 'smsPhone']);
      }
    },
    validateWechatId: function validateWechatId(rule, value, callback) {
      if (this.formData.messageNotifyFlag !== 1) {
        callback();
        return;
      }
      if (!value || !String(value).trim()) {
        callback(new Error('请输入微信号'));
        return;
      }
      var val = String(value).trim();
      if (val.length > 30) {
        callback(new Error('微信号长度不能超过30个字符'));
        return;
      }
      callback();
    },
    validateSmsPhone: function validateSmsPhone(rule, value, callback) {
      if (this.formData.messageNotifyFlag !== 1) {
        callback();
        return;
      }
      if (!value || !String(value).trim()) {
        callback(new Error('请填写手机号码'));
        return;
      }
      var val = String(value).trim();
      if (!/^\d+$/.test(val)) {
        callback(new Error('仅可输入数字'));
        return;
      }
      if (val.length !== 11) {
        callback(new Error('请输入 11 位正确手机号'));
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(val)) {
        callback(new Error('手机号格式不正确，请核对号码'));
        return;
      }
      callback();
    },
    validateNotifyEmail: function validateNotifyEmail(rule, value, callback) {
      if (this.formData.messageNotifyFlag !== 1) {
        callback();
        return;
      }
      if (!value || !String(value).trim()) {
        callback();
        return;
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(String(value).trim())) {
        callback(new Error('请输入正确的邮箱格式'));
        return;
      }
      callback();
    },
    validateNotifyFlag: function validateNotifyFlag(fieldName) {
      return function (rule, value, callback) {
        if (value !== 0 && value !== 1) {
          callback(new Error("\u8BF7\u9009\u62E9\u662F\u5426\u5F00\u542F".concat(fieldName)));
          return;
        }
        callback();
      };
    },
    // 验证最大出餐时间
    validateMaxMealTime: function validateMaxMealTime(rule, value, callback) {
      if (!this.hasPickup && !this.hasTakeout) {
        callback();
        return;
      }
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入最大出餐时间'));
        return;
      }
      var numValue = Number(value);
      if (isNaN(numValue) || numValue < 1) {
        callback(new Error('最大出餐时间最小值为1'));
        return;
      }
      callback();
    },
    fetchStoreTypeOptions: function () {
      var _fetchStoreTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var keyword,
          params,
          res,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              keyword = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              this.storeTypeLoading = true;
              _context2.p = 1;
              params = keyword && keyword.trim() ? {
                keyword: keyword.trim()
              } : {};
              _context2.n = 2;
              return (0, _rsManagement.getMerchantStoreTypeList)(params);
            case 2:
              res = _context2.v;
              this.storeTypeOptions = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
              this.refreshStoreTypeOptions();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('获取店铺类型失败:', _t2);
              this.storeTypeOptions = [];
              this.storeTypeOptionsToChose = [];
            case 4:
              _context2.p = 4;
              this.storeTypeLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function fetchStoreTypeOptions() {
        return _fetchStoreTypeOptions.apply(this, arguments);
      }
      return fetchStoreTypeOptions;
    }(),
    handleStoreTypeFocus: function handleStoreTypeFocus() {
      if (!this.storeTypeOptions.length) {
        this.fetchStoreTypeOptions();
      }
    },
    // 获取配送模板数据
    getShippingTemplateData: function getShippingTemplateData() {
      var _this12 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      console.log('getShippingTemplateData, keyword:', keyword);
      this.shippingTemplateLoading = true;
      (0, _rsManagement.getShippingTemplateList)({
        keyword: keyword
      }).then(function (res) {
        console.log('配送模板数据:', res);
        if (res) {
          _this12.shippingTemplateOptions = res;
          console.log('shippingTemplateOptions:', _this12.shippingTemplateOptions);
        }
        _this12.shippingTemplateLoading = false;
      }).catch(function (err) {
        console.error('获取配送模板数据失败:', err);
        _this12.shippingTemplateLoading = false;
      });
    },
    // 搜索配送模板
    searchShippingTemplates: function searchShippingTemplates(query) {
      console.log('搜索配送模板:', query);
      if (query !== '') {
        // 如果有搜索关键词，调用搜索接口
        this.getShippingTemplateData(query);
      } else {
        // 如果搜索关键词为空，获取所有模板
        this.getShippingTemplateData();
      }
    },
    handleDeliveryTemplateChange: function handleDeliveryTemplateChange(val) {
      var _this13 = this;
      var template = this.shippingTemplateOptions.find(function (item) {
        return String(item.key) === String(val);
      });
      // 强制同步模板type，避免从type=2切到其它模板时残留旧type导致顺丰校验仍生效
      if (template && template.type != null && template.type !== '') {
        this.formData.deliveryTemplateType = Number(template.type);
      } else {
        this.formData.deliveryTemplateType = null;
      }
      this.onDeliveryTemplateContextChanged();
      if (!template || Number(template.type) !== 2) {
        this.$nextTick(function () {
          _this13.$refs.storeForm && _this13.$refs.storeForm.clearValidate(['sfLogisticsId', 'sfFlag']);
        });
      }
      if (template && Number(template.type) === 3) {
        if (this.formData.autoDelivery == null || this.formData.autoDelivery === '') {
          this.formData.autoDelivery = 1;
        }
      }
    },
    // 初始化表单数据（编辑模式）
    initFormData: function initFormData() {
      var _this14 = this;
      console.log('initFormData called, storeData:', this.storeData);
      if (this.storeData && Object.keys(this.storeData).length > 0) {
        console.log('使用storeData初始化表单');
        // 处理数据类型转换，确保选择框字段能正确回显
        var processedData = _objectSpread({}, this.storeData);

        // 处理地区数据，将字符串转换为数组格式
        if (processedData.region) {
          if (typeof processedData.region === 'string') {
            processedData.region = processedData.region.split(',').map(function (item) {
              return Number(item);
            }).filter(function (item) {
              return item;
            });
          } else if (Array.isArray(processedData.region)) {
            processedData.region = processedData.region.map(function (item) {
              return Number(item);
            }).filter(function (item) {
              return item;
            });
          }
        } else {
          processedData.region = [];
        }

        // 处理店铺类型，后端新字段为 storeTypes，兼容旧 storeType 回显
        var storeTypesValue = processedData.storeTypes !== null && processedData.storeTypes !== undefined ? processedData.storeTypes : processedData.storeType;
        processedData.storeTypes = this.parseStoreTypes(storeTypesValue);
        delete processedData.storeType;

        // 处理其他选择框字段
        if (processedData.storeStatus !== null && processedData.storeStatus !== undefined) {
          processedData.storeStatus = String(processedData.storeStatus);
        }
        /*         if (processedData.isSelfPickup !== null && processedData.isSelfPickup !== undefined) {
                  processedData.isSelfPickup = String(processedData.isSelfPickup)
                } */
        if (processedData.businessStatus !== null && processedData.businessStatus !== undefined) {
          processedData.businessStatus = String(processedData.businessStatus);
        }
        if (processedData.usePrinterDevice !== null && processedData.usePrinterDevice !== undefined) {
          processedData.usePrinterDevice = Boolean(processedData.usePrinterDevice);
        }
        if (processedData.usePrinterDevice2 !== null && processedData.usePrinterDevice2 !== undefined) {
          processedData.usePrinterDevice2 = Boolean(processedData.usePrinterDevice2);
        }

        // 处理 wmTgFlag 字段，将字符串/数字转换为数组（回显处理）
        if (processedData.wmTgFlag !== null && processedData.wmTgFlag !== undefined && processedData.wmTgFlag !== '') {
          if (Array.isArray(processedData.wmTgFlag)) {
            // 如果已经是数组，确保元素是字符串类型
            processedData.wmTgFlag = processedData.wmTgFlag.map(function (item) {
              return String(item);
            });
          } else {
            // 如果是字符串，可能是逗号分隔的字符串，需要分割
            if (typeof processedData.wmTgFlag === 'string' && processedData.wmTgFlag.includes(',')) {
              processedData.wmTgFlag = processedData.wmTgFlag.split(',').map(function (item) {
                return String(item.trim());
              }).filter(function (item) {
                return item;
              });
            } else {
              // 单个值，转换为数组
              processedData.wmTgFlag = [String(processedData.wmTgFlag)];
            }
          }
        } else {
          processedData.wmTgFlag = [];
        }
        if (processedData.deliveryTemplateType != null && processedData.deliveryTemplateType !== '') {
          processedData.deliveryTemplateType = Number(processedData.deliveryTemplateType);
        } else {
          processedData.deliveryTemplateType = null;
        }
        if (processedData.sfFlag != null && processedData.sfFlag !== '') {
          processedData.sfFlag = Number(processedData.sfFlag);
        } else {
          processedData.sfFlag = 1;
        }
        if (processedData.sfLogisticsId != null && processedData.sfLogisticsId !== undefined) {
          processedData.sfLogisticsId = String(processedData.sfLogisticsId);
        } else {
          processedData.sfLogisticsId = '';
        }
        if ((processedData.deliveryTemplateType == null || processedData.deliveryTemplateType === '') && processedData.deliveryTemplateId && String(processedData.sfLogisticsId || '').trim() !== '') {
          processedData.deliveryTemplateType = 2;
        }

        // 兼容处理：如果后端返回的是 productType 字段，也转换为 wmTgFlag
        if ((!processedData.wmTgFlag || processedData.wmTgFlag.length === 0) && processedData.productType !== null && processedData.productType !== undefined && processedData.productType !== '') {
          if (Array.isArray(processedData.productType)) {
            processedData.wmTgFlag = processedData.productType.map(function (item) {
              return String(item);
            });
          } else if (typeof processedData.productType === 'string' && processedData.productType.includes(',')) {
            processedData.wmTgFlag = processedData.productType.split(',').map(function (item) {
              return String(item.trim());
            }).filter(function (item) {
              return item;
            });
          } else {
            processedData.wmTgFlag = [String(processedData.productType)];
          }
        }

        // 保存初始打印机序列号
        this.originalPrinterSn = processedData.printerSn || '';
        this.originalPrinterSn2 = processedData.printerSn2 || '';
        processedData.ticketTemplateIds = this.applyTicketTemplateEcho(processedData.ticketTemplateIds, processedData.ticketTemplateNameList);
        delete processedData.ticketTemplateNameList;
        processedData.businessTimeList = (0, _businessHoursUtils.parseBusinessTimeList)(processedData);
        processedData.hotelRefundConfigs = this.parseHotelRefundConfigs(processedData.hotelRefundConfigs);
        this.formData = _objectSpread(_objectSpread({}, this.formData), processedData);

        // 酒店退款配置回显处理
        var hasHotel = Array.isArray(this.formData.wmTgFlag) && this.formData.wmTgFlag.includes('3');
        if (hasHotel) {
          if (!this.formData.hotelRefundConfigs || !Array.isArray(this.formData.hotelRefundConfigs) || this.formData.hotelRefundConfigs.length === 0) {
            this.initHotelRefundConfigs();
          } else {
            this.syncHotelRefundConfigRanges();
          }
        }
        this.refreshStoreTypeOptions();
        if (this.formData.wmTgFlag.length > 0 && !this.storeTypeOptions.length) {
          this.fetchStoreTypeOptions();
        }
        console.log('初始化后的formData:', this.formData);
        console.log('保存的初始打印机序列号:', this.originalPrinterSn);

        // 修复：确保富文本编辑器内容正确回显
        this.$nextTick(function () {
          _this14.onDeliveryTemplateContextChanged();
          if (_this14.$refs.tinymceEditor && _this14.$refs.tinymceEditor.hasInit) {
            // 如果storeDesc有内容，设置到编辑器中
            if (_this14.formData.storeDesc) {
              _this14.$refs.tinymceEditor.setContent(_this14.formData.storeDesc);
              console.log('富文本编辑器内容已设置:', _this14.formData.storeDesc);
            } else {
              // 如果没有内容，清空编辑器
              _this14.$refs.tinymceEditor.setContent('');
              console.log('富文本编辑器内容已清空');
            }
          }
        });
      } else {
        console.log('storeData为空，不进行初始化');
      }
    },
    // 重置表单
    resetForm: function resetForm() {
      var _this15 = this;
      console.log('开始重置表单');
      this.formData = {
        deliveryTemplateId: null,
        deliveryTemplateType: null,
        sfLogisticsId: '',
        sfFlag: 1,
        autoDelivery: 1,
        frtTemplateId: null,
        supplierId: null,
        storeTypes: [],
        storeStatus: '',
        storeName: '',
        logo: '',
        imageUrlList: [],
        online: true,
        region: [],
        storeAddress: '',
        longitude: '',
        latitude: '',
        isSelfPickup: 0,
        isExpress: 0,
        isTakeout: 0,
        deliveryTypes: [],
        deliveryStartFee: '',
        wmTgFlag: [],
        businessStatus: '',
        businessTimeList: (0, _businessHoursUtils.createEmptyList)(),
        phone: '',
        wechatId: '',
        smsPhone: '',
        messageNotifyFlag: 0,
        storeDesc: '',
        usePrinterDevice: false,
        printerSn: '',
        ticketTemplateIds: [],
        usePrinterDevice2: false,
        printerSn2: '',
        email: '',
        remark: '',
        packingFee: '',
        maxMealTime: ''
      };
      this.storeTypeOptionsToChose = [];

      // 重置时也清空初始打印机序列号
      this.originalPrinterSn = '';
      this.originalPrinterSn2 = '';
      this.receiptTemplateOptions = [];

      // 清空富文本编辑器内容 - 修复：先清空数据，再清空编辑器
      this.$nextTick(function () {
        if (_this15.$refs.tinymceEditor) {
          // 确保编辑器实例存在且已初始化
          if (_this15.$refs.tinymceEditor.hasInit) {
            _this15.$refs.tinymceEditor.setContent('');
            console.log('已清空富文本编辑器内容');
          }
        }
      });
      if (this.$refs.storeForm) {
        this.$refs.storeForm.clearValidate();
      }
    },
    // 获取地区数据
    getAreaData: function getAreaData() {
      var _this16 = this;
      dangaoActApi.getShopSelfAddress().then(function (res) {
        _this16.areaOptions = res || [];
      }).catch(function (err) {
        console.error('获取地区数据失败：', err);
        _this16.$message.error('获取地区数据失败');
      });
    },
    // 获取店铺详情
    getStoreDetail: function getStoreDetail() {
      var _this17 = this;
      if (!this.storeId) return;
      (0, _rsManagement.getStoreInfo)(this.storeId).then(function (res) {
        if (res) {
          // 处理地区数据，将字符串转换为数组格式
          var areaArray = res.region ? res.region.split(',').map(function (item) {
            return Number(item);
          }).filter(function (item) {
            return item;
          }) : [];

          // 处理图片数据，确保是数组格式
          var imageUrlList = res.imageUrlList ? Array.isArray(res.imageUrlList) ? res.imageUrlList : [res.imageUrlList] : [];

          // 处理 wmTgFlag 字段，将字符串/数字转换为数组（回显处理）
          var wmTgFlagArray = [];

          // 优先从商户的业务类型字段获取（canWm, canTg）
          // 如果商户有这些字段，则根据这些字段来设置外卖/团购选择
          if (res.canWm !== null && res.canWm !== undefined && res.canWm === true) {
            wmTgFlagArray.push('1'); // 外卖
          }
          if (res.canTg !== null && res.canTg !== undefined && res.canTg === true) {
            wmTgFlagArray.push('2'); // 团购
          }

          // 如果从商户业务类型字段没有获取到值，则使用原有的 wmTgFlag 字段
          if (wmTgFlagArray.length === 0) {
            // 优先使用 wmTgFlag 字段
            if (res.wmTgFlag !== null && res.wmTgFlag !== undefined && res.wmTgFlag !== '') {
              if (Array.isArray(res.wmTgFlag)) {
                // 如果已经是数组，确保元素是字符串类型
                wmTgFlagArray = res.wmTgFlag.map(function (item) {
                  return String(item);
                });
              } else {
                // 如果是字符串，可能是逗号分隔的字符串，需要分割
                if (typeof res.wmTgFlag === 'string' && res.wmTgFlag.includes(',')) {
                  wmTgFlagArray = res.wmTgFlag.split(',').map(function (item) {
                    return String(item.trim());
                  }).filter(function (item) {
                    return item;
                  });
                } else {
                  // 单个值，转换为数组
                  wmTgFlagArray = [String(res.wmTgFlag)];
                }
              }
            }
            // 兼容处理：如果后端返回的是 productType 字段，也转换为 wmTgFlag
            else if (res.productType !== null && res.productType !== undefined && res.productType !== '') {
              if (Array.isArray(res.productType)) {
                wmTgFlagArray = res.productType.map(function (item) {
                  return String(item);
                });
              } else if (typeof res.productType === 'string' && res.productType.includes(',')) {
                wmTgFlagArray = res.productType.split(',').map(function (item) {
                  return String(item.trim());
                }).filter(function (item) {
                  return item;
                });
              } else {
                wmTgFlagArray = [String(res.productType)];
              }
            }
          }
          var deliveryTemplateTypeForForm = res.deliveryTemplateType != null && res.deliveryTemplateType !== '' ? Number(res.deliveryTemplateType) : null;
          if (deliveryTemplateTypeForForm == null && res.deliveryTemplateId && res.sfLogisticsId != null && String(res.sfLogisticsId).trim() !== '') {
            deliveryTemplateTypeForForm = 2;
          }
          // 确保选择框相关的字段都是正确的数据类型
          _this17.formData = _objectSpread(_objectSpread(_objectSpread({}, _this17.formData), res), {}, {
            businessTimeList: (0, _businessHoursUtils.parseBusinessTimeList)(res),
            hotelRefundConfigs: _this17.parseHotelRefundConfigs(res.hotelRefundConfigs),
            // 确保选择框字段的数据类型正确
            supplierId: res.supplierId ? Number(res.supplierId) : null,
            storeTypes: _this17.parseStoreTypes(res.storeTypes !== null && res.storeTypes !== undefined ? res.storeTypes : res.storeType),
            storeStatus: res.storeStatus !== null && res.storeStatus !== undefined ? String(res.storeStatus) : '',
            deliveryStartFee: res.deliveryStartFee !== null && res.deliveryStartFee !== undefined ? Number(res.deliveryStartFee) : '',
            wmTgFlag: wmTgFlagArray,
            deliveryFee: res.deliveryFee !== null && res.deliveryFee !== undefined ? Number(res.deliveryFee) : '',
            maxMealTime: res.maxMealTime ? Number(res.maxMealTime) : '',
            /* isSelfPickup: res.isSelfPickup !== null && res.isSelfPickup !== undefined ? String(res.isSelfPickup) : '', */
            businessStatus: res.businessStatus !== null && res.businessStatus !== undefined ? String(res.businessStatus) : '',
            region: areaArray,
            imageUrlList: imageUrlList,
            wechatId: res.wechatId || res.wechatAccount || '',
            smsPhone: res.smsPhone || res.notifyPhone || '',
            messageNotifyFlag: Number(res.messageNotifyFlag) === 1 ? 1 : 0,
            usePrinterDevice: res.usePrinterDevice !== null && res.usePrinterDevice !== undefined ? Boolean(res.usePrinterDevice) : false,
            usePrinterDevice2: res.usePrinterDevice2 !== null && res.usePrinterDevice2 !== undefined ? Boolean(res.usePrinterDevice2) : false,
            deliveryTemplateType: deliveryTemplateTypeForForm,
            sfLogisticsId: res.sfLogisticsId != null && res.sfLogisticsId !== undefined ? String(res.sfLogisticsId) : '',
            sfFlag: res.sfFlag !== null && res.sfFlag !== undefined && res.sfFlag !== '' ? Number(res.sfFlag) : 1,
            ticketTemplateIds: _this17.applyTicketTemplateEcho(res.ticketTemplateIds, res.ticketTemplateNameList)
          });
          _this17.refreshStoreTypeOptions();

          // 2. 反向映射成 el-select 需要的数组
          var types = [];
          if (res.isTakeout === 1) types.push('takeout');
          if (res.isSelfPickup === 1) types.push('self_pickup');
          if (res.isExpress === 1) types.push('express');
          _this17.formData.deliveryTypes = types;
          _this17.$nextTick(function () {
            return _this17.onDeliveryTemplateContextChanged();
          });
          console.log('处理后的formData:', _this17.formData);
          //console.log('处理后的isSelfPickup:', this.formData.isSelfPickup)

          // 修复：确保富文本编辑器内容正确回显
          _this17.$nextTick(function () {
            if (_this17.$refs.tinymceEditor && _this17.$refs.tinymceEditor.hasInit) {
              // 如果storeDesc有内容，设置到编辑器中
              if (_this17.formData.storeDesc) {
                _this17.$refs.tinymceEditor.setContent(_this17.formData.storeDesc);
                console.log('富文本编辑器内容已设置:', _this17.formData.storeDesc);
              } else {
                // 如果没有内容，清空编辑器
                _this17.$refs.tinymceEditor.setContent('');
                console.log('富文本编辑器内容已清空');
              }
            }
          });
        }
        _this17.fetchStoreTypeOptions();
      }).catch(function (err) {
        console.error('获取店铺详情失败：', err);
        _this17.$message.error('获取店铺详情失败');
      });
    },
    // LOGO上传点击事件
    handleLogoUpload: function handleLogoUpload() {
      var _this = this;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        maxCount: 1,
        model: 'product',
        pid: 1,
        onSuccess: function onSuccess(url) {
          _this.formData.logo = url;
          _this.$refs.storeForm.validateField('logo');
          _this.$message.success('LOGO上传成功');
        },
        onError: function onError(error) {
          _this.$message.error(error.message || 'LOGO上传失败');
        }
      });
    },
    // 删除LOGO
    removeLogo: function removeLogo() {
      this.formData.logo = '';
      this.$refs.storeForm.validateField('logo');
    },
    // 主图上传点击事件
    handleMainImageUpload: function handleMainImageUpload() {
      var _this$formData$imageU;
      var _this = this;

      // 计算还可以上传多少张图片
      var maxCount = 10;
      var remainingSlots = maxCount - (((_this$formData$imageU = _this.formData.imageUrlList) === null || _this$formData$imageU === void 0 ? void 0 : _this$formData$imageU.length) || 0);
      if (remainingSlots <= 0) {
        _this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(maxCount, "\u5F20\u56FE\u7247\uFF01"));
        return;
      }
      (0, _internal.uploadLocalImage)({
        multiple: true,
        maxCount: remainingSlots,
        model: 'product',
        pid: 1,
        onSuccess: function onSuccess(url) {
          // 上传成功，添加到图片列表
          if (!_this.formData.imageUrlList) {
            _this.formData.imageUrlList = [];
          }
          _this.formData.imageUrlList.push(url);
          _this.$refs.storeForm.validateField('imageUrlList');
        },
        onComplete: function onComplete(successUrls) {
          if (successUrls && successUrls.length > 0) {
            _this.$message.success("\u6210\u529F\u4E0A\u4F20".concat(successUrls.length, "\u5F20\u56FE\u7247"));
          }
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '图片上传失败');
        }
      });
    },
    // 删除主图
    removeMainImage: function removeMainImage(index) {
      this.formData.imageUrlList.splice(index, 1);
      this.$refs.storeForm.validateField('imageUrlList');
    },
    // 预览Logo
    previewLogo: function previewLogo() {
      this.currentPreviewImage = this.formData.logo;
      this.isMainImagePreview = false;
      this.imagePreviewVisible = true;
    },
    // 预览主图
    previewMainImage: function previewMainImage(image, index) {
      this.currentPreviewImage = image;
      this.currentImageIndex = index;
      this.isMainImagePreview = true;
      this.imagePreviewVisible = true;
    },
    // 上一张图片
    prevImage: function prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.currentPreviewImage = this.formData.imageUrlList[this.currentImageIndex];
      }
    },
    // 下一张图片
    nextImage: function nextImage() {
      if (this.currentImageIndex < this.formData.imageUrlList.length - 1) {
        this.currentImageIndex++;
        this.currentPreviewImage = this.formData.imageUrlList[this.currentImageIndex];
      }
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this18 = this;
      this.$refs.storeForm.validate(function (valid) {
        if (!valid) return;
        if (_this18.$refs.businessHoursPicker && !_this18.$refs.businessHoursPicker.validate()) {
          return;
        }
        if (_this18.hasHotel && !_this18.validateHotelRefundConfigs()) {
          return;
        }

        // 处理提交数据
        var submitData = _this18.prepareSubmitData();

        // 根据是否编辑模式选择不同的接口
        var apiCall = _this18.isEdit ? (0, _rsManagement.updateStore)(submitData) : (0, _rsManagement.saveStore)(submitData);
        apiCall.then(function (res) {
          _this18.$emit('submit', res);
          _this18.handleClose();
        }).catch(function (err) {
          console.error('保存失败：', err);
          _this18.$message.error(_this18.isEdit ? '编辑失败' : '添加失败');
        });
      });
    },
    // 准备提交数据
    prepareSubmitData: function prepareSubmitData() {
      var data = _objectSpread({}, this.formData);
      var toNumberOrNull = function toNumberOrNull(value) {
        return value === '' || value === null || value === undefined ? null : Number(value);
      };

      // 处理地区数据，将数组转换为逗号分隔的字符串
      if (data.region && data.region.length > 0) {
        data.region = data.region.join(',');
      } else {
        data.region = '';
      }

      // 处理 wmTgFlag 数据，将数组转换为逗号分隔的字符串（提交时）
      if (data.wmTgFlag && Array.isArray(data.wmTgFlag) && data.wmTgFlag.length > 0) {
        data.wmTgFlag = data.wmTgFlag.join(',');
      } else {
        data.wmTgFlag = '';
      }

      // 如果是编辑模式，确保包含ID
      if (this.isEdit && this.storeId) {
        data.id = this.storeId;
      }

      // 确保选择框字段的数据类型正确
      data.supplierId = data.supplierId ? Number(data.supplierId) : null;
      data.storeTypes = Array.isArray(data.storeTypes) ? data.storeTypes.join(',') : data.storeTypes || '';
      data.storeStatus = toNumberOrNull(data.storeStatus);
      /* data.isSelfPickup = data.isSelfPickup ? String(data.isSelfPickup) : '' */
      data.businessStatus = toNumberOrNull(data.businessStatus);
      data.messageNotifyFlag = toNumberOrNull(data.messageNotifyFlag);
      data.deliveryStartFee = toNumberOrNull(data.deliveryStartFee);
      data.packingFee = toNumberOrNull(data.packingFee);
      data.maxMealTime = toNumberOrNull(data.maxMealTime);
      data.deliveryTemplateId = toNumberOrNull(data.deliveryTemplateId);
      data.frtTemplateId = toNumberOrNull(data.frtTemplateId);
      delete data.discountRate;
      data.usePrinterDevice = data.usePrinterDevice !== null && data.usePrinterDevice !== undefined ? Boolean(data.usePrinterDevice) : false;
      data.usePrinterDevice2 = data.usePrinterDevice2 !== null && data.usePrinterDevice2 !== undefined ? Boolean(data.usePrinterDevice2) : false;

      // 处理图片数据，确保是数组格式
      if (!Array.isArray(data.imageUrlList)) {
        data.imageUrlList = data.imageUrlList ? [data.imageUrlList] : [];
      }

      // 处理标签数据，确保是数组格式，并转换为数字类型
      if (!Array.isArray(data.labelIdList)) {
        data.labelIdList = data.labelIdList ? [Number(data.labelIdList)] : [];
      } else {
        data.labelIdList = data.labelIdList.map(function (item) {
          return Number(item);
        });
      }
      // 前端模板类型回显字段不入库
      delete data.deliveryTemplateType;
      if (!this.isSfTemplateSelected) {
        delete data.sfLogisticsId;
        delete data.sfFlag;
      } else {
        data.sfFlag = data.sfFlag === 0 || data.sfFlag === '0' ? 0 : 1;
        data.sfLogisticsId = data.sfLogisticsId != null && data.sfLogisticsId !== undefined ? String(data.sfLogisticsId).trim() : '';
      }
      delete data.deliveryTypes;
      if (!this.showAutoDelivery) {
        delete data.autoDelivery;
      } else {
        data.autoDelivery = Number(data.autoDelivery) || 1;
      }
      delete data.ticketTemplateNameList;
      if (!this.showReceiptTemplateField) {
        delete data.ticketTemplateIds;
      } else if (Array.isArray(data.ticketTemplateIds)) {
        data.ticketTemplateIds = data.ticketTemplateIds.map(function (item) {
          return Number(item);
        }).filter(function (id) {
          return !isNaN(id);
        }).join(',');
      } else if (data.ticketTemplateIds != null && data.ticketTemplateIds !== '') {
        data.ticketTemplateIds = String(data.ticketTemplateIds);
      } else {
        data.ticketTemplateIds = '';
      }
      delete data.deliveryTypes;
      delete data.labelIdList;
      delete data.deliveryType;
      delete data.storeType;
      delete data.paymentMethods;
      delete data.discountPolicy;
      delete data.discountAmount;
      delete data.supportSelfPickup;

      // 处理酒店退款配置：仅含"酒店"时提交
      if (this.hasHotel && Array.isArray(data.hotelRefundConfigs) && data.hotelRefundConfigs.length > 0) {
        data.hotelRefundConfigs = data.hotelRefundConfigs.map(function (item) {
          return {
            startHour: Number(item.startHour),
            endHour: item.endHour == null ? null : Number(item.endHour),
            refundRate: Number(item.refundRate)
          };
        });
        data.hotelRefundConfigs = JSON.stringify(data.hotelRefundConfigs);
        data.cancelLimitHour = Number(data.cancelLimitHour);
      } else {
        delete data.hotelRefundConfigs;
        delete data.cancelLimitHour;
      }
      delete data.displayCode;
      delete data.beginTime;
      delete data.endTime;
      var businessTimeList = (0, _businessHoursUtils.serializeBusinessTimeList)(data.businessTimeList || []);
      data.businessTimeList = JSON.stringify(businessTimeList);
      return data;
    },
    handleBusinessTimeChange: function handleBusinessTimeChange() {
      var _this19 = this;
      this.$nextTick(function () {
        if (_this19.$refs.storeForm) {
          _this19.$refs.storeForm.validateField('businessTimeList');
        }
      });
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleDialogOpened: function handleDialogOpened() {
      var _this20 = this;
      this.$nextTick(function () {
        if (_this20.$refs.addressPicker) {
          _this20.$refs.addressPicker.refreshMap();
        }
      });
    }
  }
};